import { useState, useEffect, useMemo } from "react";
import { Button } from "../Buttons";
import { H3, H1, H2, Label, Anchor } from "../Text";
import {
  InputFileStatus,
  ControlField,
  InputSubData,
  CompleteDocuments,
  InputItemsConta,
  InputSubDataAdd,
  InputSubContaAdd,
} from "../Inputs";
import Circle from "../Animation/Circle";
import DialogConfirmation from "../Modal/DialogConfirmation";
import CallServiceTable from "../Tables/CallServiceTable";
import { Request } from "../../hooks/Request";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import SubModal from "../Modal/SubModal";
import { useDialog } from "../../contexts/DialogContext";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { parseJsonSafe, validateArray } from "../../utils/validate";
import { MessageOnLabel } from "./FormMessages";
import TableComplete from "../Tables/TableComplete";
import { FormAdd } from "../Inputs/ControlField";
import { Tooltip } from "react-tippy";
import { H3Custom } from "../Text/H3";
import { mapIcons } from "../../utils/constant";
import InputSubDataDocsAdd from "../Inputs/InputSubDataDocsAdd";

const FormDefault = (props) => {
  const {
    initialValues,
    onSubmit,
    validationSchema,
    fields,
    buttonName,
    handleChange,
    tittle,
    bonusContent,
    classNameBtn,
    buttonFixed = false,
    buttonSecondary = false,
  } = props;

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm }) => {
        await onSubmit(values, resetForm);
      }}
    >
      {(formik) => {
        const { isSubmitting, values, setFieldValue } = formik;
        return (
          <Form className={`flex flex-col ${buttonFixed ? "" : ""}`}>
            {tittle !== undefined ? (
              <H1 className="my-0 mb-2">{tittle}</H1>
            ) : (
              ""
            )}
            {bonusContent}
            {fields?.map((field, i) => {
              const condition = (field.condition + "").split(",");
              if (condition.indexOf(values[field.reference] + "") > -1) {
                switch (field.typeInput) {
                  case "input":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <Input field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-medium text-lg mt-[5px] text-red-400 mx-auto"
                        />
                      </ContainerInp>
                    );
                  case "requestSerialNumber":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <InputSerial field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-medium text-lg mt-[5px] text-red-400 mx-auto"
                        />
                      </ContainerInp>
                    );
                  case "file":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <InputFile field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[16px] mt-[5px] text-red-400 mx-auto"
                        />
                      </ContainerInp>
                    );
                  case "fileStatus":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <InputFileStatus field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[16px] mt-[5px] text-red-400 mx-auto"
                        />
                      </ContainerInp>
                    );
                  case "select":
                  case "selectGet":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <CustomSelectInput field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[15px] mt-[5px] text-red-400"
                        />
                      </ContainerInp>
                    );
                  case "selectAsync":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <CustomSelectInput2 field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[15px] mt-[5px] text-red-400"
                        />
                      </ContainerInp>
                    );
                  case "multiSelect":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <CustomSelectInput field={field} isMulti={true} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[15px] mt-[5px] text-red-400"
                        />
                      </ContainerInp>
                    );
                  case "subSelect":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        {values && values[field.fatherName] ? (
                          <CustomSelectInput values={values} field={field} />
                        ) : null}
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[15px] mt-[5px] text-red-400"
                        />
                      </ContainerInp>
                    );
                  case "selectNewOption":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <SelectNewOption field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[15px] mt-[5px] text-red-400"
                        />
                      </ContainerInp>
                    );
                  case "selectTable":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <SelectTable field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[15px] mt-[5px] text-red-400"
                        />
                      </ContainerInp>
                    );
                  case "checkboxes":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <Checkboxes field={field} handleChange={handleChange} />
                      </ContainerInp>
                    );
                  case "fileExcel":
                  case "reviewExcel":
                  case "correctExcel":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <GenerateExcel
                          field={field}
                          handleChange={handleChange}
                        />
                      </ContainerInp>
                    );
                  case "controlField":
                  case "IncidentField":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <ControlField
                          key={i}
                          field={field}
                          setFieldValue={setFieldValue}
                          values={values}
                        />
                      </ContainerInp>
                    );
                  case "controlFieldDelivery":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <ControlField
                          key={i}
                          field={field}
                          fieldDelivery={true}
                        />
                      </ContainerInp>
                    );
                  case "subItemsConta":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <InputItemsConta key={i} field={field} />
                      </ContainerInp>
                    );
                  case "subData":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <InputSubData key={i} field={field} />
                      </ContainerInp>
                    );
                  case "subDataAdd":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <InputSubDataAdd key={i} field={field} />
                      </ContainerInp>
                    );
                  case "subDataAddDocs":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <InputSubDataDocsAdd key={i} field={field} />
                      </ContainerInp>
                    );
                  case "subDataContaAdd":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <InputSubContaAdd key={i} field={field} />
                      </ContainerInp>
                    );
                  case "completeDocuments":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <CompleteDocuments key={i} field={field} />
                      </ContainerInp>
                    );
                  case "completeDocumentsAdd":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <CompleteDocuments
                          key={i}
                          field={field}
                          addDocument={true}
                        />
                      </ContainerInp>
                    );
                  case "selectListFields":
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <SelectListFields field={field} />
                      </ContainerInp>
                    );
                  default:
                    return (
                      <ContainerInp
                        index={i}
                        key={i}
                        color={field.color}
                        fields={fields}
                        className="flex flex-col"
                      >
                        <Input field={field} />
                        <ErrorMessage
                          name={field.name}
                          component="span"
                          className="font-bold text-[16px] mt-[5px] text-red-400 mx-auto"
                        />
                      </ContainerInp>
                    );
                }
              } else {
                return null;
              }
            })}
            {isSubmitting ? (
              <Circle className="mt-4" />
            ) : (
              <>
                <div
                  className={`${
                    buttonFixed
                      ? "fixed bottom-4 right-8 w-[95%] lg:w-[45%] 2xl:w-[37%] flex gap-2 justify-end items-center"
                      : "w-full"
                  }`}
                >
                  <Button
                    onClick={() =>
                      formik.setValues((a) => ({ ...a, btnSecondary: false }))
                    }
                    type="submit"
                    className={`mt-4 py-4 ${
                      buttonFixed ? "w-full" : "w-full"
                    } ${classNameBtn}`}
                  >
                    {buttonName}
                  </Button>
                  {buttonSecondary ? (
                    <Button
                      onClick={() =>
                        formik.setValues((a) => ({ ...a, btnSecondary: true }))
                      }
                      type="submit"
                      className={`mt-4 py-4 px-6 ${
                        buttonFixed ? "w-fit" : "w-full"
                      } ${classNameBtn} bg-[#618bcc]`}
                    >
                      <i className="fas fa-share-square"></i>
                    </Button>
                  ) : null}
                </div>
                {buttonFixed ? <div className="h-16"></div> : null}
              </>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

const Input = ({ field }) => {
  return field.type === "checkbox" ? (
    <div className={`flex flex-row items-center gap-x-2`}>
      <Field
        as="input"
        autoComplete="current-password"
        className="bg-white border border-gray-300 px-1 py-2 rounded-md outline-none caret-blue-600 focus:border-blue-600 disabled:opacity-100 disabled:bg-gray-300"
        // className="rounded-[7px] placeholder-black placeholder:text-[15px] placeholder:opacity-50 placeholder:font-normal p-4 mt-1 font-light text-base bg-white/50"
        type={field.type}
        id={field.name}
        name={field.name}
        placeholder={field.placeholder}
        disabled={field.lockEdition}
        onWheel={(e) => e.target.blur()}
      />
      <Label htmlFor={field.name} className={field.className}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && field.type !== "checkbox" && <MessageOnLabel />}
      </Label>
    </div>
  ) : (
    <div
      className={`flex ${
        field.type === "checkbox" ? "flex-row items-center gap-x-8" : "flex-col"
      }`}
    >
      <Label htmlFor={field.name} className={field.className}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && field.type !== "checkbox" && <MessageOnLabel />}
      </Label>
      <Field
        as={
          field.type === "textArea" || field.type === "textarea"
            ? "textarea"
            : "input"
        }
        autoComplete="current-password"
        className="bg-white border border-gray-300 px-3 py-2 rounded-md outline-none caret-blue-600 focus:border-blue-600 disabled:opacity-100 disabled:bg-gray-300"
        // className="rounded-[7px] placeholder-black placeholder:text-[15px] placeholder:opacity-50 placeholder:font-normal p-4 mt-1 font-light text-base bg-white/50"
        onWheel={(e) => e.target.blur()}
        type={field.type}
        id={field.name}
        name={field.name}
        placeholder={field.placeholder ? field.placeholder : field.label}
        disabled={field.lockEdition}
      />
    </div>
  );
};

const InputSerial = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  function handleClick() {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres generar un {field.label}?</H3>}
        onClose={dialogClose}
        method="post"
        url={`/dataset/procedure/${field.id}/field/${field.fieldId}/correlative`}
        texBtn="Generar"
        handleSuccess={field.reload}
        data={{ value: field.initial }}
      />
    );
  }
  return (
    <div
      className={`flex ${
        field.type === "checkbox" ? "flex-row items-center gap-x-8" : "flex-col"
      }`}
    >
      <Label htmlFor={field.name} className={field.className}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && <MessageOnLabel />}
      </Label>
      <div className="flex items-start gap-2">
        <Field
          as={
            field.type === "textArea" || field.type === "textarea"
              ? "textarea"
              : "input"
          }
          autoComplete="current-password"
          className="w-full md:shadow-[0_4px_4px_rgba(0,0,0,0.25)] rounded-[7px] placeholder-black placeholder:text-[15px] placeholder:opacity-50 placeholder:font-normal 
          p-4 mt-1 mb-6 font-light text-base bg-white/50 md:bg-white/75 disabled:opacity-100 disabled:bg-gray-300"
          type={field.type}
          id={field.name}
          name={field.name}
          disabled={field.lockEdition}
        />
        {!field.lockEdition ? (
          <Button onClick={handleClick} className="py-4 mt-1">
            <i className="fas fa-sort-numeric-down"></i>
          </Button>
        ) : null}
      </div>
    </div>
  );
};

const InputFile = ({ field }) => {
  const { setFieldValue, values } = useFormikContext();
  return (
    <>
      <Label
        htmlFor={field.name}
        className={`${field.className} my-[0] mt-[0px] mb-[0px]`}
        // className={`${field.className} my-[0] mt-[25px] mb-[0px]`}
      >
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && <MessageOnLabel />}
      </Label>
      {(field.initial || values[field.name]) &&
      (typeof field.initial === "string" ||
        typeof values[field.name] === "string") ? (
        <H3 className="font-medium my-[10px] text-[12px] sm:text-[15px] xl:text-[18px]  text-start mb-[10px]">
          Archivo subido:{" "}
          <Anchor
            className="text-[#1d4ed8]"
            href={field.initial || values[field.name]}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver archivo
          </Anchor>
        </H3>
      ) : null}
      <div
        className="md:shadow-[0_4px_4px_rgba(0,0,0,0.25)]
        rounded-[7px] placeholder-black placeholder:text-[15px]
        placeholder:opacity-50 placeholder:font-normal
        px-[17px] sm:py-[15px] font-light
        text-[15px] bg-white/50 md:bg-white/75"
      >
        <input
          autoComplete="current-password"
          className="text-sm text-grey-500
          file:mr-5 file:py-2 file:px-6
          file:rounded-full file:border-0
          file:text-sm file:font-medium
          file:bg-[#1d4ed8] file:text-white
          hover:file:cursor-pointer hover:file:bg-[#1d4fd8ce]"
          type={field.type}
          id={field.name}
          name={field.name}
          placeholder={field.placeholder}
          onChange={(fileData) => {
            setFieldValue(field.name, fileData.target.files[0]);
          }}
        />
      </div>
    </>
  );
};

const CustomSelectInput = ({ field, isMulti = false }) => {
  const { setFieldValue, values } = useFormikContext();
  const { data, loading, call } = Request({
    urlApi:
      field.typeInput === "subSelect"
        ? `${field.fatherUrl}/${field.urlApi}/${values[field.fatherName]}`
        : field.urlApi ?? null,
  });

  useEffect(() => {
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.urlApi, values[field.fatherName]]);

  function onChange(selectedOptions) {
    if (isMulti) {
      const valuesString = selectedOptions
        .map((option) => option.value)
        .join("|");
      setFieldValue(field.name, valuesString);
    } else {
      setFieldValue(field.name, selectedOptions?.value || "");
    }
  }

  function handleOption() {
    if (field.urlApi) {
      if (validateArray(data)) {
        return data.map((option) => ({
          value: option[field.value],
          label:
            (field.labelOptionParam
              ? option[field.labelOptionParam] + ". "
              : "") + option[field.labelOption],
        }));
      }
      return [];
    }
    return field.options ?? [];
  }

  function handlePlaceholder(value) {
    if (!value) return "Seleccionar...";
    const listAux = field.urlApi ? data ?? [] : field.options ?? [];
    const selectedValues = isMulti ? value.split("|") : [value];

    return selectedValues
      .map((val) => {
        const OptionFind = listAux.find(
          (element) => element[field.value] === val
        );
        return OptionFind ? OptionFind[field.labelOption] : val;
      })
      .join(", ");
  }

  return (
    <div className="flex flex-col">
      <Label className="my-[20px]" htmlFor={field.name}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && <MessageOnLabel />}
      </Label>
      <Select
        className="w-full"
        isSearchable
        isMulti={isMulti}
        closeMenuOnSelect={!isMulti}
        onChange={onChange}
        styles={{ placeholder: (base) => ({ ...base, color: "black" }) }}
        // placeholder={handlePlaceholder(values[field.name] || "")}
        placeholder={
          handleOption().find((opt) => opt.value === values[field.name]) ||
          "Seleccionar..."
        }
        isLoading={field.urlApi ? !loading : false}
        options={handleOption()}
        isDisabled={field.lockEdition}
        value={
          isMulti
            ? values[field.name]
              ? values[field.name]
                  .split("|")
                  .map((val) => {
                    const listAux = field.urlApi
                      ? data ?? []
                      : field.options ?? [];
                    const OptionFind = listAux.find(
                      (element) => element[field.value] === val
                    );
                    return OptionFind
                      ? { value: val, label: OptionFind[field.labelOption] }
                      : null;
                  })
                  .filter(Boolean)
              : []
            : handleOption().find((opt) => opt.value === values[field.name]) ||
              null
        }
      />
    </div>
  );
};

const CustomSelectInput2 = ({ field, isMulti = false }) => {
  const { setFieldValue, values } = useFormikContext();
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const { data, loading, call } = Request({
    urlApi:
      field.typeInput === "subSelect"
        ? `${field.fatherUrl}/${field.urlApi}/${values[field.fatherName]}`
        : field.urlApi ?? null,
  });

  useEffect(() => {
    if (field.fatherName && !values[field.fatherName]) return;
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.urlApi, values[field.fatherName]]);

  const allOptions = useMemo(() => {
    if (field.urlApi && Array.isArray(data)) {
      return data.map((option) => ({
        value: option[field.value],
        label:
          (field.labelOptionParam
            ? option[field.labelOptionParam] + ". "
            : "") + option[field.labelOption],
      }));
    }
    return field.options ?? [];
  }, [data]);

  useEffect(() => {
    if (inputValue.length === 0) {
      setFilteredOptions([]);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);
    const delayDebounce = setTimeout(() => {
      const lowerInput = inputValue.toLowerCase();
      const results = allOptions.filter((opt) =>
        opt.label.toLowerCase().includes(lowerInput)
      );
      setFilteredOptions(results);
      setIsSearching(false);
    }, 800);

    return () => clearTimeout(delayDebounce);
  }, [inputValue, allOptions]);

  function onChange(selectedOptions) {
    if (isMulti) {
      const valuesString = selectedOptions
        .map((option) => option.value)
        .join("|");
      setFieldValue(field.name, valuesString);
    } else {
      setFieldValue(field.name, selectedOptions?.value || "");
    }
  }

  function handlePlaceholder(value) {
    if (!value) return "Seleccionar...";
    const listAux = allOptions;
    const selectedValues = isMulti ? value.split("|") : [value];

    return selectedValues
      .map((val) => {
        const OptionFind = listAux.find((element) => element.value === val);
        return OptionFind ? OptionFind.label : val;
      })
      .join(", ");
  }

  const selectedValue = useMemo(() => {
    if (isMulti && values[field.name]) {
      return values[field.name]
        .split("|")
        .map((val) => allOptions.find((opt) => opt.value === val))
        .filter(Boolean);
    }
    return allOptions.find((opt) => opt.value === values[field.name]) || null;
  }, [values, field.name, allOptions, isMulti]);

  return (
    <div className="flex flex-col">
      <Label className="my-[20px]" htmlFor={field.name}>
        {field.labelCustom ?? field.label}
        {field.validate && <MessageOnLabel />}
      </Label>

      <Select
        className="w-full"
        isSearchable
        isMulti={isMulti}
        closeMenuOnSelect={!isMulti}
        onChange={onChange}
        isLoading={field.urlApi ? loading || isSearching : isSearching}
        isDisabled={field.lockEdition}
        value={selectedValue}
        options={inputValue.length > 0 ? filteredOptions : []}
        placeholder={handlePlaceholder(values[field.name] || "")}
        onInputChange={(val) => setInputValue(val)}
        noOptionsMessage={() =>
          inputValue.length === 0 ? "Escribe para buscar..." : "Sin resultados"
        }
      />
    </div>
  );
};

const SelectListFields = ({ field }) => {
  let fieldnames = field.format?.split("|");
  const permissionField = parseJsonSafe(field?.permission);
  const [selectValue, setSelectValue] = useState("");
  const { data: fieldOpts } = Request({
    urlApi: `field/byNames?names=${fieldnames
      .map(encodeURIComponent)
      .join("&names=")}`,
  });

  const { data, call } = Request({
    urlApi: `procedure/${field.id}/dataValues?fieldnames=${fieldnames
      .map(encodeURIComponent)
      .join("&fieldnames=")}`,
  });

  const { openDialog, dialogClose } = useDialog();
  function generateFormAdd(
    data,
    onClose,
    reload,
    field,
    fieldOpts,
    fieldlabel = null
  ) {
    const commonProps = {
      data,
      onClose,
      allowEmpty: true,
      addFieldsForm: validateArray(permissionField?.formFields)
        ? permissionField?.formFields
        : [],
      // [
      //   { label: "N° Sol/Pla", name: "det_nroSolPlanilla", placeholder: "0", type: "number", typeInput: "number" },
      //   {
      //     label: "Importe Bs",
      //     name: "amount",
      //     placeholder: "0",
      //     type: "number",
      //     typeInput: "number",
      //   },
      //   { label: "Girar cheque para: ", name: "det_chequePara", placeholder: "Ej: Banco Union SA", type: "text", typeInput: "text" },
      //   { label: "N° Cheque", name: "det_nroCheque", placeholder: "0", type: "number", typeInput: "number" },
      //   { label: "Emitente", name: "det_banco", placeholder: "Ej: ECO", type: "text", typeInput: "text" },
      //   { label: "Concepto del pago", name: "det_concepto", placeholder: "Concepto del pago", type: "textarea", typeInput: "textarea", },
      //   {
      //     label: "Descripción",
      //     name: "description",
      //     placeholder: "Descripción",
      //     type: "textarea",
      //     typeInput: "textarea",
      //   }
      // ]
      reload,
      field,
      // fieldDelivery: fieldDelivery,
    };

    if (selectValue) {
      return (
        <FormAdd
          {...commonProps}
          addTitle={
            fieldOpts?.find((f) => f.id + "" === selectValue)?.label ??
            fieldlabel
          }
          reload={() => {
            reload();
            setSelectValue("");
          }}
          field={{ ...field, fieldId: selectValue }}
          formFields={permissionField?.formFields}
        />
      );
    } else {
      return <FormAdd {...commonProps} />;
    }
  }

  function handleForm(data) {
    const parsedDetails = data.details ? JSON.parse(data.details) : [];
    const formattedData = {
      ...data,
      ...parsedDetails,
    };
    openDialog(
      generateFormAdd(
        formattedData,
        dialogClose,
        call,
        field,
        null,
        data.fieldlabel
      )
    );
  }

  const HandleCreateForm = () => {
    if (selectValue !== "") {
      openDialog(generateFormAdd(data, dialogClose, call, field, fieldOpts));
    }
  };

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar el archivo?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/fileState/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }
  function handleStatusUpdate(data) {
    let status = data.status === "Validado" ? null : "Validado";
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar el archivo?</H3>}
        onClose={dialogClose}
        method="put"
        url={`/fileState/${data.id}/changeStatus/${status}`}
        texBtn="Modificar"
        handleSuccess={call}
      />
    );
  }

  const options = fieldOpts?.map((opt) => ({
    value: opt.id,
    label: opt.label,
  }));

  return (
    <div className="flex flex-col gap-2">
      <Label className="my-[20px]" htmlFor={field.name}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && <MessageOnLabel />}
      </Label>
      <div>
        <Select
          name="FieldId"
          value={options?.find((opt) => opt.value === selectValue) || null}
          onChange={(selectedOption) =>
            setSelectValue(selectedOption?.value || "")
          }
          options={options ?? []}
          placeholder="Seleccionar tipo de documento"
          isClearable
        />

        {selectValue !== "" && (
          <Button
            onClick={() => HandleCreateForm()}
            // onClick={() => handleForm(values.field, values.isNew)}
            className="py-2 mt-1 w-full"
          >
            Adicionar documento
          </Button>
        )}
      </div>
      <div className="overflow-auto flex flex-col gap-3 pt-4">
        {data &&
          fieldnames.map((fieldname, index) => {
            const fileStates = data[fieldname + "FileStates"];

            const modifiedFileStates = fileStates?.map((fileState) => {
              const parsedDetails = fileState.details
                ? typeof fileState.details === "string"
                  ? JSON.parse(fileState.details)
                  : fileState.details
                : [];

              return {
                ...fileState,
                ...parsedDetails,
              };
            });

            return (
              data[fieldname + "FileStates"]?.length > 0 && (
                <div className="bg-stone-400/20 shadow-sm shadow-stone-400 p-2 rounded-md">
                  <H3Custom className="text-start mb-1 text-sm font-semibold">
                    {data[fieldname + "FileStates"][0].fieldlabel}
                  </H3Custom>
                  <TableComplete
                    header={[
                      ...(validateArray(permissionField?.tableFields)
                        ? permissionField?.tableFields?.map((tableItem) =>
                            tableItem.type === "custom"
                              ? {
                                  name: "url",
                                  label: "Enlace",
                                  type: "custom",
                                  builder: (item) => {
                                    if (item) {
                                      return (
                                        <Anchor
                                          href={item}
                                          className="text-[#1d4ed8] underline"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          Abrir
                                        </Anchor>
                                      );
                                    } else {
                                      return "-";
                                    }
                                  },
                                }
                              : tableItem
                          )
                        : []),
                      // {name: "det_nroSolPlanilla", label: "N° Sol/Pla" },
                      // {name: "amount", label: "Importe Bs", },
                      // {name: "det_chequePara", label: "Girar cheque para" },
                      // {name: "description", label: "Concepto de Pago", },
                      // {name: "det_nroCheque", label: "N° Cheque" },
                      // {name: "det_banco", label: "Emitente" },
                      // {
                      //   name: "url",
                      //   label: "Enlace",
                      //   type: "custom",
                      //   builder: (item) => {
                      //     if (item) {
                      //       return (
                      //         <Anchor
                      //           href={item}
                      //           className="text-[#1d4ed8] underline"
                      //           target="_blank"
                      //           rel="noopener noreferrer"
                      //         >
                      //           Abrir
                      //         </Anchor>
                      //       );
                      //     } else {
                      //       return "-";
                      //     }
                      //   },
                      // },
                      // {
                      //   name: "creationDate",
                      //   label: "Fecha",
                      //   type: "date",
                      // },
                      {
                        name: "add",
                        type: "action",
                        label: "Opciones",
                        sticky: true,
                        actions: [
                          {
                            label: "Editar",
                            icon: "fas fa-edit",
                            action: handleForm,
                            color: "text-[#1d4ed8]",
                          },
                          ...(permissionField?.changeStatus
                            ? [
                                {
                                  icon: "fas fa-trash",
                                  builder: (item) => {
                                    if (item) {
                                      return (
                                        <div
                                          className={` text-xl cursor-pointer`}
                                          onClick={() =>
                                            handleStatusUpdate(item)
                                          }
                                        >
                                          <Tooltip
                                            // title={act.validate ? (item.showButtonJoinPdfs ? item.showButtonJoinPdfs : act.label) : act.label}
                                            title={"Cambiar estado"}
                                            position="right"
                                            trigger="mouseenter"
                                          >
                                            {mapIcons(item.status)}
                                          </Tooltip>
                                        </div>
                                      );
                                    } else {
                                      return "-";
                                    }
                                  },
                                },
                              ]
                            : []),
                          ...(permissionField?.openUrl
                            ? [
                                {
                                  icon: "fas fa-trash",
                                  builder: (item) => {
                                    if (item) {
                                      return (
                                        <Tooltip
                                          // title={act.validate ? (item.showButtonJoinPdfs ? item.showButtonJoinPdfs : act.label) : act.label}
                                          title={"Abrir"}
                                          position="right"
                                          trigger="mouseenter"
                                        >
                                          <Anchor
                                            href={
                                              item[permissionField?.openUrl]
                                            }
                                            className={`${
                                              item[permissionField?.openUrl] !==
                                                null &&
                                              item[permissionField?.openUrl] !==
                                                ""
                                                ? "text-[#1d4ed8]"
                                                : "text-gray-400"
                                            } text-lg`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <i className="far fa-file-pdf" />
                                          </Anchor>
                                        </Tooltip>
                                      );
                                    } else {
                                      return "-";
                                    }
                                  },
                                },
                              ]
                            : []),
                          {
                            label: "Eliminar",
                            icon: "fas fa-trash",
                            action: handleDelete,
                            color: "text-red-500",
                          },
                        ],
                      },
                    ]}
                    data={modifiedFileStates}
                  />
                </div>
              )
            );
          })}
      </div>
    </div>
  );
};

const SelectNewOption = ({ field }) => {
  const { setFieldValue, values } = useFormikContext();
  const { data, loading, call } = Request({
    urlApi: field.urlApi ? `${field.urlApi}` : null,
  });
  useEffect(() => {
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.urlApi]);

  function onChange(value) {
    setFieldValue(field.name, value.value);
    setFieldValue(`${field.name}_isNew`, value.__isNew__);

    if (field.saveMultipleFields && field.additionalFields) {
      const selectedOption = data?.find(
        (option) => option[field.value] === value.value
      );

      if (selectedOption) {
        Object.entries(field.additionalFields).forEach(
          ([fieldName, sourceKey]) => {
            setFieldValue(fieldName, selectedOption[sourceKey]);
          }
        );
      }
    }
  }
  function handlePlaceholder(value) {
    let listAux = field.urlApi ? data : field.options;
    if (value && validateArray(listAux)) {
      const OptionFind = listAux.find(
        (element) => element[field.value || "value"] === value
      );
      if (OptionFind) {
        return field.urlApi
          ? (field.labelOptionParam
              ? OptionFind[field.labelOptionParam] + ". "
              : "") + OptionFind[field.labelOption]
          : OptionFind.label;
      } else {
        return value;
      }
    }
    return "Seleccionar...";
  }
  function handleOption() {
    if (field.urlApi) {
      if (validateArray(data)) {
        return data.map((option) => ({
          value: option[field.value],
          label:
            option.code && option.description
              ? `${option.code} - ${option.description}`
              : option[field.labelOption],
        }));
      }
      return [];
    } else {
      return field.options;
    }
  }

  return (
    <div className="flex flex-col">
      <Label className="my-[20px]" htmlFor={field.name}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && <MessageOnLabel />}
      </Label>
      <CreatableSelect
        isSearchable={true}
        onChange={onChange}
        styles={{
          placeholder: (base) => ({
            ...base,
            color: "black",
          }),
        }}
        // defaultInputValue={values[field.name]}
        // placeholder={values[field.name] ? values[field.name] : 'Seleccionar...'}
        placeholder={handlePlaceholder(
          values[field.aditionalName]
            ? values[field.aditionalName]
            : values[field.name]
            ? values[field.name]
            : null
        )}
        isOptionSelected={false}
        isLoading={field.urlApi ? !loading : false}
        options={handleOption()}
        isDisabled={field.lockEdition}
      />
    </div>
  );
};

const SelectTable = ({ field }) => {
  const { setFieldValue, values } = useFormikContext();
  const [modalView, setModalView] = useState(false);
  function handleSelect(fieldTable) {
    setFieldValue(field.name, fieldTable);
    setModalView(false);
  }

  const ShowValue = ({ children }) => (
    <div className="bg-white w-full px-2 py-3 shadow-[0_4px_4px_rgba(0,0,0,0.25)] rounded-md">
      {children[field.labelSelect]}
    </div>
  );

  return (
    <>
      <Label htmlFor={field.name} className={field.className}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && <MessageOnLabel />}
      </Label>
      <div onClick={() => setModalView(true)} className="flex gap-2 mb-2">
        {values[field.name] ? (
          <ShowValue>{values[field.name]}</ShowValue>
        ) : (
          <div className="bg-white w-full h-9 shadow-[0_4px_4px_rgba(0,0,0,0.25)] rounded-md"></div>
        )}
        <Button className="py-1 px-2 min-w-fit text-white">
          Buscar <i className="fas fa-search"></i>
        </Button>
      </div>
      <SubModal onClose={() => setModalView(false)} activateForm={modalView}>
        <H2>LISTA PARA ADICIONAR CAMPOS EXISTENTES</H2>
        <CallServiceTable
          urlApi="/field"
          header={[
            {
              name: "label",
              label: "Nombre del campo",
              filter: true,
            },
            //   {
            //     name: 'type',
            //     label: 'Tipo de campo',
            //     filter: false,
            //     type: 'translate',
            //     translate: {
            //       text: 'Texto',
            //       file: 'Archivo',
            //       fileRead: 'Archivo',
            //       number: 'Numero',
            //       selectGet: 'Lista desplegable',
            //       checkbox: 'Casilla de verificación',
            //       textArea: 'Caja de texto multi-línea',
            //       date: 'Fecha',
            //     },
            //   },
            {
              name: "edit",
              type: "action",
              label: "Añadir",
              actions: [
                {
                  label: "Añadir campo",
                  icon: "fas fa-circle-plus",
                  action: handleSelect,
                  color: "text-[#1d4ed8]",
                },
              ],
            },
          ]}
        />
      </SubModal>
    </>
  );
};

const Checkboxes = ({ field }) => {
  const { data, call } = Request({
    urlApi: field.urlApi ? `${field?.urlApi}` : null,
  });
  useEffect(() => {
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.urlApi]);

  if (field.options || field.urlApi) {
    return (
      <>
        <H2 className="mb-4">
          {field.labelCustom ? field.labelCustom : field.label}
          {field.validate && <MessageOnLabel />}
        </H2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
          {field.options ? (
            <>
              {field?.options?.map((option, i) => {
                return (
                  <div
                    key={i}
                    className="flex items-center justify-between border-2 border-red-000"
                  >
                    <Label htmlFor={option.label}>{option.label}</Label>
                    <Field
                      className="cursor-pointer"
                      type="checkbox"
                      name={field.name}
                    />
                  </div>
                );
              })}
            </>
          ) : (
            <>
              {data?.map((option, i) => {
                return (
                  <div
                    key={i}
                    className="flex items-center justify-between border-2 border-red-000"
                  >
                    <Label htmlFor={option.label}>{option.label}</Label>
                    <Field
                      id={option.label}
                      className="cursor-pointer"
                      type="checkbox"
                      value={"" + option[field.value]}
                      name={field.name}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
      </>
    );
  }
};

const GenerateExcel = ({ field }) => {
  return (
    <div className="w-full my-[20px]">
      <Label className="my-[20px]" htmlFor={field.name}>
        {field.labelCustom ? field.labelCustom : field.label}
        {field.validate && <MessageOnLabel />}
      </Label>
      <div className="flex justify-between items-center gap-[10px]">
        <div
          className="md:shadow-[0_4px_4px_rgba(0,0,0,0.25)]
                  rounded-[7px] placeholder-black placeholder:text-[15px]
                  placeholder:opacity-50 placeholder:font-normal
                  px-[17px] py-2.5 font-light text-[15px] 
                  bg-white/50 md:bg-white/75 w-[100%]"
        >
          <H3 className="font-normal text-lg text-start">
            Archivo generado:{" "}
            {field.initial ? (
              <Anchor
                className="text-[#1d4ed8]"
                href={field.initial}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver archivo
              </Anchor>
            ) : (
              <span>--</span>
            )}
          </H3>
        </div>
        <Button
          className="p-2"
          type="button"
          onClick={() => field.action(field)}
        >
          <FontAwesomeIcon
            className="text-white text-xl"
            icon="fa-solid fa-file-excel"
          />
        </Button>
      </div>
    </div>
  );
};

const ContainerInp = ({ children, className, color, fields, index }) => {
  return (
    <div
      style={{
        background: `${color}31`,
        // borderRadius: `10px 10px ${
        //   fields.length > index - 1
        //     ? "10px 10px"
        //     : fields[index + 1].color === color
        //     ? "0px 0px"
        //     : "10px 10px"
        // }`,
        borderRadius: `5px`,
      }}
      className={`${className} px-1 py-2 mb-1`}
    >
      {children}
    </div>
  );
};

export default FormDefault;
